import { Component, OnInit } from '@angular/core';
import { DoctorService } from '../../services/doctor.service';
import { CommonService } from '../../services/common.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit {
  breed: any;
  commentsarray= [];
  comment: any;
  loading: any;
  blog = [];
  lifestage: any;
  allblogs = []
  constructor(private doctorService: DoctorService, private commonService: CommonService, private router: Router) { }

  ngOnInit() {
    this.getRecentBlogs();
    this.commonService.getLifestages()
    .subscribe(
      (x) => {
        this.lifestage = x;
      }
     );
     this.doctorService.getallBreeds()
     .subscribe(
       (x) => {
         this.breed = x;
       }
      );
      this.doctorService.getBlogs()
      .subscribe(
        (x) => {
          this.allblogs = x;
        }
      );
  }
  getRecentBlogs() {
    this.loading = true;
    this.doctorService.getRecentBlogs()
    .subscribe(
    (x) => {
      this.loading = false;
      this.blog = x;
      this.eliminate();
    /*  for (let i = 0; i < this.blog.length ; i++) {
          this.getCommentsOnBlog(this.blog[i].id);
      }
  */
    });
   }
  eliminate() {
    let i = this.blog.length - 1;
    while (i > 4 ) {
        this.blog.splice(i, 1);
        i --
      }
  }
  getCommentsOnBlog(bid) {
    let totalcomment;
    this.doctorService.getCommentsOnBlog(bid)
      .subscribe(
      (x) => {
        this.comment = x;
        if (this.comment && this.comment.length > 0) {
          totalcomment = this.comment.length;
          this.commentsarray['id' + bid] = totalcomment;
        }else {
          totalcomment = 0;
          this.commentsarray['id' + bid] = totalcomment;
        }
      }
      );
  }
  pettypeCount(pt) {
    let total = 0;
    for (let i = 0; i < this.allblogs.length ; i++) {
      if (this.allblogs[i].pet_type === pt) {
        total = total + 1;
      }
    }
    return total;
  }
  breedCount(bt) {
    let total = 0;
    for (let i = 0; i < this.allblogs.length ; i++) {
      if (this.allblogs[i].breed_id === bt) {
        total = total + 1;
      }
    }
    return total;
  }
  lifestageCount(lt) {
    let total = 0;
    for (let i = 0; i < this.allblogs.length ; i++) {
      if (this.allblogs[i].lifestage_id === lt) {
        total = total + 1;
      }
    }
    return total;
  }
  categoryCount(ct) {
    let total = 0;
    for (let i = 0; i < this.allblogs.length ; i++) {
      if (this.allblogs[i].category === ct) {
        total = total + 1;
      }
    }
    return total;
  }
  setmaincategory(cat) {
    this.router.navigate(['/blogs/home/' + 'category',  cat]);
  }
  setLifestagecategory(id) {
    localStorage.setItem('cattype', 'life' );
    this.router.navigate(['/blogs/home/'  + 'all',  id]);
  }
  setBreedcategory(id) {
    localStorage.setItem('cattype', 'breed' );
    this.router.navigate(['/blogs/home/' + 'all' , id]);
  }
  setPetTypecategory(id) {
    localStorage.setItem('cattype', 'ptype' );
    this.router.navigate(['/blogs/home/' + 'all', id]);
  }
  goToDetail(id, url) {
    this.router.navigate(['/blogs/detail/' + id, url])
  }
}
